export const SILENT_REQUEST_HEADER_KEY = "x-silent-request";
export const CURRENT_COMPANY_ID_HEADER_KEY = "x-current-company-id";
